import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import Layout from "./components/Layout/Layout";
import { Contracts } from "./pages/Sales/Contracts/Contracts";
import { ToastProvider } from "./Providers/ToastProvider";
import { AdminView } from "./pages/Administration/AdminView";
import { Employee } from "./pages/Employee/Employee";
import { KeycloakProvider, PrivateRoute } from "./keycloak";
import { Sales } from "./pages/Sales/Sales";
import { Loader } from "./components/Loader/Loader";
import { SocketProvider } from "./socket/SocketProvider/SocketProvider";
import { SchedulingAndExecution } from "./pages/SchedulingAndExecution/SchedulingAndExecution";
import { ErrorPage, ErrorPageType } from "./components/ErrorPage/ErrorPage";
import { Profile } from "./pages/Profile/Profile";
import { DisabledOverlayProvider } from "./Providers/DisabledOverlayProvider";
import { OutApp } from "./Providers/OutApp";
import { Reports } from "./pages/Reports/Reports";
import { Analytics } from "./pages/Analytics/Analytics";
import Authiorize from "./pages/authorizen/Authiorize";
import { PublicApp } from "./PublicApp";
import { DCSQueryClient } from "./queryClient";

const PUBLIC_PATHS = ["/account-deletion"];

const PageLoader = () => (
  <div style={{ height: "100vh" }}>
    <Loader pageLoader />
  </div>
);

const App = () => {
  const isPublicPath = PUBLIC_PATHS.some((p) =>
    window.location.pathname.startsWith(p)
  );
  if (isPublicPath) {
    return <PublicApp />;
  }

  return (
    <BrowserRouter>
      <ToastProvider>
        <QueryClientProvider client={DCSQueryClient}>
          <OutApp>
            <KeycloakProvider
              configUrl="/keycloak.json"
              loader={<PageLoader />}
            >
              <DisabledOverlayProvider>
                <SocketProvider>
                  <Layout>
                    <Routes>
                        <Route path="/authorize/*" element={<Authiorize />} />
                        <Route element={<PrivateRoute />}>
                          <Route
                            path="/"
                            element={<Navigate to="/profile" replace />}
                          />
                          <Route path="/sales/*" element={<Sales />} />
                          <Route
                            path="/management/employees/*"
                            element={<Employee />}
                          />
                          <Route path="/contracts/*" element={<Contracts />} />

                          <Route
                            path="/scheduling-execution/*"
                            element={<SchedulingAndExecution />}
                          />
                          <Route
                            index
                            path="/administration/*"
                            element={<AdminView />}
                          />
                          <Route
                            index
                            path="/profile/*"
                            element={<Profile />}
                          />
                          <Route
                            path="/reports/:reportId"
                            element={<Reports />}
                          />
                          <Route
                            path="/analytics/:reportId"
                            element={<Analytics />}
                          />
                          <Route
                            index
                            path="/access-denied"
                            element={
                              <ErrorPage type={ErrorPageType.Forbidden} />
                            }
                          />
                          <Route
                            index
                            path="/not-found"
                            element={
                              <ErrorPage type={ErrorPageType.NotFound} />
                            }
                          />
                          <Route
                            path="*"
                            element={<Navigate to="/not-found" replace />}
                          />
                        </Route>
                    </Routes>
                  </Layout>
                </SocketProvider>
              </DisabledOverlayProvider>
            </KeycloakProvider>
          </OutApp>
        </QueryClientProvider>
      </ToastProvider>
    </BrowserRouter>
  );
};

export default App;
